// @ts-nocheck

import Delta from "quill-delta";
import { isNil } from "ramda";
import "./module.less";
// const Keys = {
//   TAB: 9,
//   ENTER: 13,
//   ESCAPE: 27,
//   UP: 38,
//   DOWN: 40,
// };

class PiLinkModule {
  quill;
  options;
  triggering = false;
  // 触发时的光标
  triggerCursorIndex = 0;
  searchText = "";
  // 更新节点数据 只需要在textChange=user时触发1次
  isGetNodeData = false;
  getNodeDataTimer = 0;

  // 拼音打字时，不判断空格
  // 苹果输入法在拼音打字时 会用空格对拼音分词
  isComposition = false;
  constructor(quill, options) {
    this.quill = quill;
    this.options = options;
    this.quill.on("text-change", this.onTextChange.bind(this));
    this.quill.on("selection-change", this.onSelectionChange.bind(this));

    // @ts-ignore
    this.quill.container.addEventListener("click", e => {
      const piLink = e.target?.closest(".piLink");
      if (piLink) {
        const orgId = piLink.getAttribute("data-org-id");
        const nodeId = piLink.getAttribute("data-node-id");
        if (orgId && nodeId) {
          this.options.onClick(orgId, nodeId);
        }
      }
    });

    // @ts-ignore
    this.quill.container.addEventListener("compositionstart", () => {
      this.isComposition = true;
    });
    // @ts-ignore
    this.quill.container.addEventListener("compositionend", () => {
      this.isComposition = false;
    });
  }
  onTextChange(delta, oldDelta, source) {
    if (source === "user") {
      if (this.triggering) {
        if (isNil(delta.ops) || delta.ops && delta.ops.length < 2) {
          this.hideMenu("3");
          return;
        }
        const [op1, op2] = delta.ops;
        let endIndex = op1.retain;
        if ("insert" in op2 && Array.isArray(op2.insert) && op2?.insert?.length) {
          endIndex += op2.insert.length;
        }
        this.handleSearch(endIndex);
      } else {
        // 按# 触发菜单
        const insert = delta.ops?.[1]?.insert || delta.ops?.[0]?.insert;
        if (insert === "#") {
          this.showMenu();
        }
      }

      // 更新标题
      if (this.isGetNodeData) return;
      clearTimeout(this.getNodeDataTimer);
      this.getNodeDataTimer = setTimeout(() => {
        this.isGetNodeData = true;
        clearTimeout(this.getNodeDataTimer);
        this.getNodeDataTimer = setTimeout(() => {
          this.updateNodeData(oldDelta);
        }, 500);
      }, 500);
    }
  }
  onSelectionChange(range, oldRange) {
    if (!this.triggering) return;
    if (!range) {
      this.hideMenu("1");
      return;
    }

    // HighlightKeyWords module 影响，导致粘贴的时候，selection-change 会被触发
    if (isNil(oldRange) && range.index === 0 && range.length === 0) {
      return;
    }

    // 光标离开matchtext的时候 关闭
    const validCursorPos = [this.triggerCursorIndex, this.triggerCursorIndex + this.searchText.length];
    if (range.index < validCursorPos[0] || range.index > validCursorPos[1]) {
      this.hideMenu("2");
    }
  }
  showMenu() {
    const range = this.quill.getSelection();
    if (!range) return;
    this.triggerCursorIndex = range.index;
    this.triggering = true;
    this.searchText = "";

    // 当前#符号的定位
    this.options.showMenu(this.quill.getBounds(range.index));
  }
  hideMenu() {
    if (!this.triggering) return;
    this.triggering = false;
    this.triggerCursorIndex = 0;
    this.searchText = "";
    this.options.hideMenu();
  }
  handleSearch(endIndex) {
    if (endIndex < this.triggerCursorIndex) {
      this.hideMenu("3");
      return;
    }
    const len = endIndex - this.triggerCursorIndex;
    let text = this.quill.getText(this.triggerCursorIndex, len);
    if (
    /**
     * 判断是否有输入法插入空格，
     * 如果是粘贴就不判断
     */
    !this.isComposition &&
    /**
     * 仅在双空格时断开
     */
    ~text.indexOf("  ")) {
      this.hideMenu("4");
      return;
    }
    // 选中文字
    this.searchText = text;
    this.options.onSearchChange(this.searchText);
  }
  async updateNodeData(allDelta) {
    if (!allDelta.ops) return;
    let getNodes = [];

    // 找到所有pilink
    const piLinkDeltas = allDelta.filter(op => op.insert?.piLink);
    piLinkDeltas.forEach(x => {
      const {
        orgId,
        nodeId
      } = x.insert?.piLink;
      getNodes.push({
        orgId,
        nodeId
      });
    });
    const res = await this.options.getNodeData(getNodes);
    if (!res || !res?.length) return;
    // 判断需要更新title的节点 更新delta
    const newTitlesMap = res.reduce((a, b) => {
      a[`${b.o}-${b.n}`] = b.t;
      return a;
    }, {});
    const curDelta = this.quill.getContents();
    const newDelta = new Delta(JSON.parse(JSON.stringify(curDelta.ops)));
    if (!curDelta.ops) return;
    curDelta.ops?.forEach((x, index) => {
      if (!x.insert?.piLink || !newDelta.ops) return;
      const {
        orgId,
        nodeId
      } = x.insert?.piLink;
      let title = x.insert.piLink.title;
      const newTitle = newTitlesMap[`${orgId}-${nodeId}`];
      if (title === newTitle) return;
      if (newTitle === undefined) {
        title = "获取失败";
      } else {
        title = newTitlesMap[`${orgId}-${nodeId}`] || "无标题";
      }
      const newPiLinkOp = x.insert?.piLink;
      newDelta.ops[index].insert.piLink = {
        ...newPiLinkOp,
        title: title
      };
    });
    const op = curDelta.diff(newDelta);
    if (op.ops?.length) {
      this.quill.updateContents(op, "user");
    }
  }

  // 选择后 插入关联
  onSelect(data, insertIndex) {
    const currentCursorIndex = insertIndex ?? this.quill.getSelection()?.index ??
    // NOTE: 搜索过后鼠标点击选择导致 getSelection 获取不到光标位置
    // @ts-ignore
    this.quill?.selection?.savedRange.index; // NOTE: 获取记忆的光标位置
    if (!currentCursorIndex) {
      console.log("quill-pi-link insert !range");
      return;
    }
    const delLen = this.searchText.length + 1;
    let index = currentCursorIndex - delLen;
    this.quill.deleteText(index, delLen, "user");
    this.quill.insertEmbed(index, "piLink", {
      orgId: data.o,
      nodeId: data.n,
      title: data.t || "无标题"
    }, "user");
    this.quill.insertText(index + 1, " ", "user");
    // @ts-ignore
    this.quill.setSelection(index + 2, "user");
  }
}
export default PiLinkModule;